<template>
  <div class="name-component">
    <div
      class="fl-sym-mt-6 fl-sym-p-2 fl-sym-border fl-sym-border-graduate fl-sym-rounded-sm"
      @click="$refs['name'].focus()"
    >
      <div class="fl-sym-text-secondary fl-sym-text-xxs">
        Name or Nickname
      </div>
      <input
        ref="name"
        class="focus:fl-sym-outline-none fl-sym-w-full"
        v-model="value.name"
        required
      />
    </div>
    <div class="fl-sym-text-xxs fl-sym-mt-2 fl-sym-text-secondary">
      <img src="@/assets/Info-blue.png" width="13" class="info-icon-blue" />
      Must be less than 10 characters long
    </div>
    <switch-box
      class="fl-sym-mt-5"
      v-model="value.species"
      :options="options"
    />
    <div
      class="fl-sym-mt-6 fl-sym-p-2 fl-sym-border fl-sym-border-graduate fl-sym-rounded-sm"
      @click="$refs['date_of_birth'].focus()"
    >
      <div class="fl-sym-text-secondary fl-sym-text-xxs">Date of birth</div>
      <input
        ref="date_of_birth"
        class="focus:fl-sym-outline-none fl-sym-w-full"
        type="date"
        v-model="value.date_of_birth"
        required
      />
    </div>
    <div class="fl-sym-text-xxs fl-sym-mt-2 fl-sym-text-secondary">
      <img src="@/assets/Info-blue.png" width="13" class="info-icon-blue" /> If
      unsure, enter your best guess
    </div>
  </div>
</template>

<script>
import switchBox from "@/components/form/checkbox/switch-animals.vue"
import { mapState } from "vuex"
export default {
  components: {
    switchBox,
  },
  computed: {
    ...mapState({
      pet: (state) => state.pet.pet,
    }),
  },
  props: {
    value: {
      default: () => ({
        name: "",
        date_of_birth: null,
        species: "dog",
      }),
    },
    type: Object,
  },
  data() {
    return {
      options: [
        {
          name: "Dog",
          value: "dog",
        },
        {
          name: "Cat",
          value: "cat",
        },
      ],
    }
  },
}
</script>

<style>
.info-icon-blue {
  display: inline;
  position: relative;
  top: -2px;
  margin-right: 2px;
}
</style>
